import React from "react";
import { NewUserModal } from "../components/NewUserModal";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const NewUserForInternalModal = (props: Props) => {
  return <NewUserModal
    isOpen={props.isOpen}
    onClose={props.onClose}
    title={RESX.UserType.NewInternalUser}
    environment="internal"
    submitFunc={formState => window.CoreApi.UserForInternalAdmin.Invite({
      bookkeepingIds: formState.bookkeepings.map(b => b.bookkeepingId),
      email: formState.email,
      firstName: formState.firstName,
      freeFieldProfileId: formState.freeFieldProfile.freeFieldProfileId,
      language: formState.language.value,
      lastName: formState.lastName,
      userName: formState.username,
    })}
    redirectUrl={(userId: number) => routes.internalUser_Detail(userId).absolute} />
}